import { useContext, useState } from "react";
import classNames from "classnames";

import { AppContexts } from "../../../providers";
import GoogleAutoComplete from "../../common/GoogleAutoComplete";

const BuilderPropertyStep = ({ onComplete }) => {
  const authContext = useContext(AppContexts.AuthContext);
  const utilContext = useContext(AppContexts.UtilContext);
  const [propertyName, setPropertyName] = useState("");
  const [address, setAddress] = useState("");
  const [placeId, setPlaceId] = useState("");
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const handleAddressChange = (nextAddress) => {
    setAddress(nextAddress || "");
    setPlaceId("");
    setErrors((current) => ({
      ...current,
      address: undefined,
      google_place_id: undefined,
    }));
  };

  const submit = async (event) => {
    event.preventDefault();
    const nextErrors = {};
    if (!propertyName.trim()) nextErrors.property_name = "Enter a property name.";
    if (!address.trim() || !placeId) {
      nextErrors.address = "Select the property address from the suggestions.";
    }

    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      return;
    }

    setSubmitting(true);
    setErrors({});
    try {
      const place = await utilContext.place(placeId);
      const result = await authContext.createGuideProperty({
        source_type: "manual",
        listing_url: "",
        property_name: propertyName.trim(),
        google_place_id: place.place_id,
        address: place.formatted_address,
        lat: place.geometry?.location?.lat,
        lng: place.geometry?.location?.lng,
      });
      await onComplete(result);
    } catch (error) {
      const response = error?.response?.data || error || {};
      setErrors({
        ...(response.fields || {}),
        form:
          response.error ||
          "We couldn't save this property. Check the details and try again.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="guide-onboarding-property-step">
      <p className="guide-onboarding-intro">
        Start with the property guests will visit. Nothing goes live until you
        review and publish the guide.
      </p>

      <form onSubmit={submit} noValidate>
        <div className="uk-margin">
          <label className="uk-form-label" htmlFor="property-name">
            Property name
          </label>
          <input
            id="property-name"
            className={classNames("uk-input", { error: errors.property_name })}
            placeholder="Seaside Cottage"
            value={propertyName}
            onChange={(event) => setPropertyName(event.target.value)}
          />
          {errors.property_name && (
            <p className="guide-onboarding-error">{errors.property_name}</p>
          )}
        </div>

        <div className="uk-margin">
          <label className="uk-form-label">Property address</label>
          <GoogleAutoComplete
            className={classNames("uk-input", { error: errors.address })}
            width="100%"
            placeholder="Begin typing, then select an address"
            address={address}
            onChange={handleAddressChange}
            onSelect={(value, option) => {
              setAddress(value);
              setPlaceId(option.text);
              setErrors((current) => ({
                ...current,
                address: undefined,
                google_place_id: undefined,
              }));
            }}
          />
          {errors.address && (
            <p className="guide-onboarding-error">{errors.address}</p>
          )}
        </div>

        {errors.form && (
          <div className="uk-alert-danger" data-uk-alert role="alert">
            {errors.form}
          </div>
        )}

        <div className="guide-onboarding-actions">
          <button
            className="uk-button hms-btn hms-red-btn"
            type="submit"
            disabled={submitting}
          >
            {submitting ? "Saving property…" : "Continue to branding"}
          </button>
          <span>About 5 minutes to a useful first draft</span>
        </div>
      </form>
    </div>
  );
};

export default BuilderPropertyStep;
